<template>
  <div id="TextQuestion">
    <p
      class="dmh-confirm-text"
      :class="[isWhiteSpacePreWrap ? 'pre-wrap' : 'custom-space']"
      v-html="decodeData(question.sub_text)"
    ></p>
  </div>
</template>

<script>
import { isEmbedded } from "../../utils/helpers";

export default {
  name: "TextQuestion",
  props: ["question", "setAnswer", "onNavigate"],
  data() {
    return {
      selectedOptionIndex: null,
      isChecked: false,
      checkbox: null
    };
  },
  computed: {
    isWhiteSpacePreWrap() {
      return ["Informed Consent", "How we can best support you"].includes(
        this.question.sub_heading
      );
    }
  },
  mounted() {
    if (isEmbedded()) {
      this.$el.querySelectorAll("a[href]").forEach(link => {
        if (/^(tel|sms|mailto):/i.test(link.getAttribute("href"))) {
          link.classList.add("disabled-link");
          link.addEventListener("click", event => event.preventDefault());
        }
      });
    }

    this.checkbox = document.getElementById("agreementCheckbox");
    const subText = this.question?.sub_text || "";
    if (!subText.includes("Ticking this box") && !this.checkbox) {
      this.setAnswer(true);
    } else {
      if (this.checkbox) {
        const initiallyChecked = !!this.question?.previous_answer;
        this.checkbox.checked = initiallyChecked;
        this.isChecked = initiallyChecked;
        this.setAnswer(initiallyChecked ? true : null);
        this.checkbox.addEventListener("change", () => {
          this.updateCheckboxState();
        });
        this.checkbox.addEventListener("keydown", e => {
          if (e.key === "Enter") {
            this.checkbox.checked = !this.checkbox.checked;
            this.updateCheckboxState();
          }
        });
      }
    }
  },
  methods: {
    selectOptionIndex(i) {
      this.setAnswer(i);
      this.selectedOptionIndex = i;
    },
    decodeData(data) {
      try {
        return atob(data);
      } catch (error) {
        return data;
      }
    },
    openPrivacyPolicy() {
      if (this.onNavigate) {
        this.onNavigate("/privacy-policy");
      }
    },
    updateCheckboxState() {
      this.isChecked = this.checkbox.checked;
      this.setAnswer(this.isChecked ? true : null);
    }
  }
};
</script>
<style lang="less">
#TextQuestion {
  display: flex;
  flex-direction: column;
  align-items: center;
  #agreementCheckbox {
    cursor: pointer;
    width: 14px;
    height: 14px;
    margin-right: 4px;
  }
  .privacy-text {
    font-family: var(--font-bold, "DMSans Bold");
  }
  .privacy-link {
    font-family: var(--font-bold, "DMSans Bold");
    text-decoration: underline;
  }
  p {
    text-align: left;
    width: 100%;
    font-size: 1.6rem;
    color: #1e1e22;
  }
  small {
    font-size: 1.5rem;
  }
  img {
    max-width: 600px;
    border-radius: 16px;
    cursor: not-allowed;
  }
  .phone_numbers {
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 20px;
    box-shadow: 0px 4px 25px 0px #1E1E220D;
    border-radius: 12px;
    padding: 20px;
    margin: 32px auto;
  }

  .phone_number_row {
    text-align: center;
  }

  .phone_number_link {
    color: var(--brand-primary);
  }

  .dmh-confirm-text {

    p, .phone_number_row {
      font-family: var(--font-regular, "DMSans");
      color: #1e1e22;
      font-size: 1.6rem;
    }

    h3 {
      padding: 0;
      letter-spacing: 0;
      margin-bottom: 0;
    }
    ul,
    p {
      margin-bottom: 0;
    }
    h3,
    ul,
    li,
    p,
    div,
    span {
      color: #1e1e22;
    }
    b {
      font-family: var(--font-bold, "DMSans Bold");
    }
    section {
      border: none !important;
      padding: 0 !important;
    }

    a {
      color: var(--brand-primary);
      text-decoration: underline;
    }
    a.disabled-link {
      cursor: default;
      opacity: 0.6;
      text-decoration: none;
    }
  }
  .pre-wrap {
    white-space: pre-wrap;

    p {
      white-space: pre-wrap;
      margin-bottom: 12px;
    }
  }
  .custom-space {
    ul,
    ol {
      &:not(:first-child) {
        padding-left: 20px;
        margin-top: 20px;
      }
    }
    h3:not(:first-child) {
      margin-top: 24px;
    }
    li {
      margin-top: 16px;
    }
    p:not(:first-child),
    section,
    .phone_numbers {
      margin-top: 20px;
    }
  }
}
</style>
